import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import FieldEditor from "editor/FieldEditor";
import GlobalEvents from "base/GlobalEvents";

class AddContentModal extends Modal {
    constructor(content_type, settings = {}) {
        super(settings);


        let $loadingContent = eotwJSXFactory('div', {class: "admin-modal__loading"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#main-loading'></use></svg>");

        let $content = (
            eotwJSXFactory('form', {class: "admin-form"}, [
                $loadingContent
            ])
        );


        this.setContent($content);
        this.editors = {};

        Ajax.get('content', content_type, {depth: 7}).then((content_type) => {
            if (content_type.addModalInputs.length === 0) {
                window.location.href = content_type.links.add;
                return;
            }

            let $newContent = (
                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--full"}, [
                    eotwJSXFactory('h2', null, [content_type.modalTitle]),

                        content_type.addModalInputs.map((input) => (
                            eotwJSXFactory('div', {class: "admin-form__row"}, [
                                eotwJSXFactory('label', {class: "admin-form__label"}, [input.input.name]),
                                eotwJSXFactory('div', {class: "js-content-field", 'data-type': input.input.type.modalEditor, 'data-id': input.input.id, 'data-name': input.input.slug}).data("settings", input.input.settings),
                                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                            ])
                        )),

                    eotwJSXFactory('div', {class: "admin-form__col--full admin-modal__buttons"}, [
                        eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Submit"]),
                        eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel", type: "button"}, ["Cancel"])
                    ])
                ])
            );

            $content.append($newContent);

            let loadingPromises = [];
            const me = this;
            $content.find(".js-content-field").each(function () {
                let $input = $(this);
                let data = {$input: $input, settings: settings};
                let editor;
                if (me.emit('enableInput.' + $input.attr("data-name"), data) && $input.length > 0) {
                    editor = FieldEditor.get_editor($(this).attr("data-type"), $input, $.extend({context: "admin-form", name: $input.data("name")}, $input.data("settings")), false);
                } else if ('undefined' !== typeof data.editor) {
                    editor = data.editor;
                } else {
                    return;
                }

                editor.on("loading", (prom) => {
                    loadingPromises.push(prom);
                });
                editor.create();
                me.editors[$(this).attr("data-name")] = editor;
            });
            if (loadingPromises.length > 0) {
                $newContent.hide();
            }

            Promise.all(loadingPromises).then(() => {
                $newContent.show();
                $loadingContent.remove();

                validator.updateInputs();

                this.emit("loaded");
            });

            let validator = FormValidator.attach($content).on("submit", () => {
                if(!GlobalEvents.emit('content.addPost', {content_type, editors: this.editors, modal: this}) || !me.emit('submit', {editors: this.editors})) return;

                let $form = (
                    eotwJSXFactory('form', {method: "POST", action: content_type.links.add}, [
                        Object.keys(this.editors).map((slug) => {
                            return eotwJSXFactory('input', {type: "hidden", name: slug, value: JSON.stringify(this.editors[slug].getValue())})
                        })
                    ])
                );
                $('body').append($form);
                $form.submit();
            });

        }).catch((e) => {
            $content.html(
                eotwJSXFactory('div', null, [
                    eotwJSXFactory('p', {class: "admin-form"}, ['Sorry, an error occurred. Please try again - ' + e.message]),
                    eotwJSXFactory('div', {class: "admin-form__col--full admin-modal__buttons"}, [
                        eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel", type: "button"}, ["Cancel"])
                    ])
                ])
            );
        });
        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.destroy();
            return false;
        });
    }

    destroy() {
        Object.values(this.editors).forEach((editor) => editor.destroy());
        this.editors = {};
        super.destroy();
    }

}

export default AddContentModal;
